import React from 'react';
import { FormDrawer } from './FormDrawer';

export const QuotationItemsForm = ({
  isOpen,
  onClose,
  onSave,
  isSaving = false,
  isDarkMode = false,
  isEditing = false,
  formData,
  onChange,
  formError = '',
  quotationOptions = [],
  itemDescriptionOptions = [],
  itemFormatOptions = [],
  itemColorOptions = [],
}) => {
  const sections = [
    {
      key: 'item',
      title: 'Datos del ítem',
      fields: [
        { key: 'item_code', label: 'Código', disabled: true, readOnly: true },
        {
          key: 'quotation_id',
          label: 'Cotización',
          type: 'select',
          options: quotationOptions,
        },
        {
          key: 'product_sku',
          label: 'Producto (código de catálogo)',
          type: 'select',
          options: itemDescriptionOptions,
          fullWidth: true,
        },
        {
          key: 'color',
          label: 'Color',
          type: 'select',
          options: itemColorOptions,
        },
        { key: 'color_code', label: 'Código color', disabled: true, readOnly: true },
        { key: 'quantity', label: 'Cantidad', type: 'number', step: '0.01' },
        {
          key: 'unit',
          label: 'Formato',
          type: 'select',
          options: itemFormatOptions,
        },
        { key: 'unit_price', label: 'Precio unitario', type: 'number', step: '0.01' },
        { key: 'discount_percent', label: 'Descuento (%)', type: 'number', step: '0.01' },
        {
          key: 'status',
          label: 'Estado',
          type: 'select',
          options: [
            { value: 'Activo', label: 'Activo' },
            { value: 'Inactivo', label: 'Inactivo' },
          ],
        },
      ],
    },
  ];

  return (
    <FormDrawer
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      isDarkMode={isDarkMode}
      title={isEditing ? 'Editar Ítem' : 'Agregar Ítem'}
      subtitle="Formulario de ítems de cotización"
      sections={sections}
      formData={formData}
      onChange={onChange}
      formError={formError}
      width={560}
    />
  );
};

export default QuotationItemsForm;
